import React, { Fragment, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { updateProfileSurvey } from '../../actions/profile';

const WEBASK_ID = 'hi8kalb87';

export const WebaskProvider = ({ children, profile }) => {
  const timerRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    const needLoadScript = !(timerRef.current || !profile || !profile.isLoaded);

    if (needLoadScript) {
      if (!profile.survey && profile.tariff && profile.tariff.countDay > 0) {
        timerRef.current = setTimeout(() => {
          if (window.WebAsk && window.WebAsk.popup && !window.WebAsk.isAnswered(WEBASK_ID)) {
            window.WebAsk.popup(WEBASK_ID);
            const updatedProfile = {
              ...profile,
              survey: true
            };
            dispatch(updateProfileSurvey(updatedProfile));
          }
        }, 2 * 60 * 1000);
      }
    }
  }, [profile]);

  useEffect(() => {
    if (!window.WebAsk && profile.isLoaded && !profile.survey) {
      (function (w, e, b, a, s, k) {
        w[e] = w[e] || b;
        w[e].b.push({
          id: ['a26279', WEBASK_ID],
          overlay: 'rgba(128, 128, 128, 0.3)',
          type: 'popup'
        });
        a.async = true;
        a.src = s + k;
        document.querySelector('head').appendChild(a);
      }(window, 'WebAsk', { b: [] }, document.createElement('script'), document.location.protocol === 'https:' ? 'https:' : 'http:', '//app.webask.io/static/api.js'));
    }
  }, [profile]);

  return (
    <Fragment>
      {children}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Webask/WebaskProvider.js